<template>
  <b-card
    no-body
    class="pt-2 pb-2 card-create card p-2 container-card mb-1"
    id="create-mapping-banner"
  >
    <b-row>
      <b-col cols="12" class="d-flex justify-content-end px-3">
        <add-button
          v-if="!setMappingBannerTable.payload.length == 0"
          btnLabel="Add Banner"
          @click.native="openMappingModal"
        />
      </b-col>
      <b-col cols="12" v-if="setMappingBannerTable.payload.length == 0">
        <content-no-item
          :textNoImg="'Add Banner'"
          :actionFunc="openMappingModal"
        />
        <div></div>
      </b-col>
      <b-col cols="12" v-else>
        <b-row>
          <b-col cols="12" class="d-flex justify-content-end my-1 px-3">
            <div class="search-mapping-banner-container">
              <search :on-search-input="onSetValueSearch" />
            </div>
          </b-col>
          <b-col cols="12" class="mb-1">
            <div class="content-mapping-toggle-status mb-1 p-relative">
              <b-form-checkbox
                v-model="mappingSelect"
                class="mapping-checkbox"
                @change="selectAllBanner"
                ><span>Select</span>
              </b-form-checkbox>
              <div class="count-banner-select" v-if="hasSelectbanner">
                <div
                  v-if="
                    countBannerSelect != setMappingBannerTable.payload.length
                  "
                >
                  <span>{{ countBannerSelect }}</span
                  >/{{ setMappingBannerTable.payload.length }} of
                  {{ setMappingBannerTable.payload.length }}
                </div>
              </div>
              <div v-if="hasSelectbanner">
                <div
                  class="mapping-text"
                  v-if="
                    countBannerSelect != setMappingBannerTable.payload.length
                  "
                >
                  <span
                    >All {{ countBannerSelect }} list on this page
                    selected.</span
                  ><span @click="selectedAllBanner"
                    >Select all {{ setMappingBannerTable.payload.length }}</span
                  >
                </div>
                <div class="mapping-text" v-else>
                  <span
                    >All
                    {{ setMappingBannerTable.payload.length }} conversations in
                    inbox are selected.</span
                  ><span @click="clearAllBanner">Clear selection</span>
                </div>
              </div>

              <div class="d-flex" v-if="hasSelectbanner">
                <div
                  class="ml-2 mapping-status-btn-delete"
                  @click="removeMappingBanner"
                >
                  <trash class="mapping-status-icon-delete" />
                </div>
              </div>
            </div>
            <b-table
              :fields="fields"
              :items="setMappingBannerTable.payload"
              :filter="searchValue.query"
              :per-page="pagination.perPage"
              :total-rows="pagination.rows"
              :current-page="pagination.currentPage"
              responsive
              bordered
              borderless
              sticky-header
              v-sortable-row="sortableRowOptions"
              class="default-static-table"
              :class="!sortableRowOptions.disabled ? 'reorder' : null"
              :key="tableModeReorder + keyChange"
            >
              <!-- <template #head(checkbox)>
                <b-form-checkbox class="mapping-checkbox"> </b-form-checkbox>
              </template> -->
              <template #cell(selected)="data">
                <b-form-checkbox
                  class="mapping-checkbox"
                  v-model="data.item.selected"
                >
                </b-form-checkbox>
              </template>
              <template #cell(banner_image_url)="data">
                <div class="" v-if="data.item.banner_image_url">
                  <img
                    class="w-100 h-100 banner-image-column"
                    :src="data.item.banner_image_url"
                    alt=""
                    draggable="false"
                  />
                </div>
                <div class="text-center" v-else>-</div>
              </template>
              <template #cell(seq)="data">
                <span>{{ data.index + 1 }}</span>
              </template>
              <template #cell(valid_from)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_from)
                }}</span>
              </template>
              <template #cell(valid_through)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_through)
                }}</span>
              </template>
              <template #cell(updatedtime)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.updatedtime)
                }}</span>
              </template>
              <template #cell(banner_status)="data">
                <div
                  class="d-flex align-items-center"
                  v-if="data.item.banner_status === 'Active'"
                >
                  <feather-icon icon="CircleIcon" class="active-icon mr-2" />

                  <span>{{ data.item.banner_status }}</span>
                </div>
                <div class="d-flex align-items-center" v-else>
                  <feather-icon icon="CircleIcon" class="inActive-icon mr-2" />
                  <span class="inActive-label">{{
                    data.item.banner_status
                  }}</span>
                </div>
              </template>
              <template #cell(actions)="data">
                <action-group
                  :resolveAction="resolveBannerAction"
                  :setActionList="setBannerActionList"
                  :itemData="data"
                />
              </template>
            </b-table>
          </b-col>
          <b-col cols="12" class="px-3">
            <!-- <reorder-button
              :mode="tableModeReorder"
              @click.native="handleTableReorder"
            /> -->
            <pagination-with-reorder
              reordering
              entity-editable
              :pagination="pagination"
              @reorder="handleTableReorder"
              @entityChange="onFilterEntity"
              @pageChange="onPageChange"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <mapping-banner-modal
      :isSet="setMode"
      :mappingList="setMappingBannerTable"
      :displayKey="displayKey"
      :queryDataKey="queryDataKey"
      :queryId="queryId"
      @onCloseModal="closeMappingModal"
      @mapping="initMappingBanner"
      v-if="modalType.mapping"
    />
    <copy-banner-modal
      :bannerId="modalConfig.bannerId"
      @onCloseModal="resolveCloseModalAction(setBannerActionList.copy)"
      v-if="modalType.copy"
    />
    <move-to-set-banner-modal
      :bannerId="modalConfig.bannerId"
      :mappingBanner="setMappingBannerTable.payload"
      :setBannerInformation="setBannerInformation"
      @onCloseModal="resolveCloseModalAction(setBannerActionList.move, $event)"
      v-if="modalType.move"
    />
    <reorder-modal
      v-if="modalType.reorder"
      :currentIndex="indexReorder"
      :reorderAction="reorderBanner"
      @onCloseModal="resolveCloseModalAction(setBannerActionList.reorder)"
    />
  </b-card>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormCheckbox,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import MappingBannerModal from "./MappingBannerModal.vue";
import CopyBannerModal from "./CopyBannerModal.vue";
import MoveToSetBannerModal from "./MoveToSetBannerModal.vue";
import ReorderModal from "@core/components/reorder-modal/ReorderModal.vue";
import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import ReorderButton from "@/views/components/button/ReorderButton.vue";
import SaveButton from "@/views/components/button/SaveButton.vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import CancelButton from "@/views/components/button/CancelButton.vue";

import Sortable from "sortablejs";
import useCreateMappingBanner from "../hooks/useCreateMappingBanner";
import CardNoItem from "@/@core/components/card-no-item/CardNoItem.vue";
import ContentNoItem from "@/@core/components/card-no-item/ContentNoItem.vue";
import Trash from "@/@core/components/svg/common/Trash.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
const createSortable = (el, options, vnode) => {
  return Sortable.create(el, {
    ...options,
  });
};

const sortableRow = {
  name: "sortableRow",
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
};

export default {
  directives: {
    sortableRow,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BButton,
    BFormCheckbox,
    BFormCheckboxGroup,
    AddButton,
    Search,
    ReorderButton,
    SaveButton,
    CancelButton,
    ActionGroup,
    MappingBannerModal,
    CopyBannerModal,
    MoveToSetBannerModal,
    ReorderModal,
    CardNoItem,
    ContentNoItem,
    Trash,
    PaginationWithReorder,
  },
  props: {
    displayKey: String,
    queryDataKey: String,
    queryId: Number,
    mappingBanner: { type: Array, default: [] },
    setBannerInformation: Object,
    loading: { type: Boolean, default: false },
  },
  setup(props) {
    const {
      fields,
      setMode,
      tableModeReorder,
      setMappingBannerTable,
      setBannerActionList,
      sortableRowOptions,
      keyChange,
      modalType,
      indexReorder,
      modalConfig,
      resolveDateWithSeperator,
      resolveBannerAction,
      closeMappingModal,
      openMappingModal,
      handleTableReorder,
      saveMappingBanner,
      initMappingBanner,
      selectAllBanner,
      removeMappingBanner,
      resolveCloseModalAction,
      reorderBanner,
      onSetValueSearch,
      searchValue,

      countBannerSelect,
      clearAllBanner,
      selectedAllBanner,
      mappingSelect,
      hasSelectbanner,
      pagination,
      onPageChange,
      onFilterEntity,
    } = useCreateMappingBanner(props);

    return {
      fields,
      setMode,
      tableModeReorder,
      setMappingBannerTable,
      setBannerActionList,
      sortableRowOptions,
      keyChange,
      modalType,
      indexReorder,
      modalConfig,
      resolveDateWithSeperator,
      resolveBannerAction,
      closeMappingModal,
      openMappingModal,
      handleTableReorder,
      saveMappingBanner,
      initMappingBanner,
      selectAllBanner,
      removeMappingBanner,
      resolveCloseModalAction,
      reorderBanner,
      onSetValueSearch,
      searchValue,

      countBannerSelect,
      clearAllBanner,
      selectedAllBanner,
      mappingSelect,
      hasSelectbanner,
      pagination,
      onPageChange,
      onFilterEntity,
    };
  },
};
</script>

<style></style>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/pages/banner/set-mapping-banner.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";
</style>
